/* eslint-disable unicorn/filename-case */
import axios from 'axios';

import { endpoints } from '@/API/endpoints';
import { getFormError } from '@/helpers/getResponseErrors';
import { FormDataType } from '@/types';

const AuthApi = {
	async login(data: FormDataType) {
		try {
			const response = await axios.post(endpoints.urlToken, data);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},

	async getConfirmCode(data: FormDataType) {
		try {
			const response = await axios.post(endpoints.urlGetConfirmCode, data);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},

	async verifyConfirmCode(data: FormDataType) {
		try {
			const response = await axios.post(endpoints.urlVerifyConfirmCode, data);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},

	async resetPassword(data: FormDataType) {
		try {
			const response = await axios.post(endpoints.urlResetPassword, data);
			return response;
		} catch (error: unknown) {
			return getFormError(error);
		}
	},
};

export { AuthApi };
